import { render, staticRenderFns } from "./GRACEIschemiaAssess.vue?vue&type=template&id=3c25683a&scoped=true"
import script from "./GRACEIschemiaAssess.vue?vue&type=script&lang=js"
export * from "./GRACEIschemiaAssess.vue?vue&type=script&lang=js"
import style0 from "./GRACEIschemiaAssess.vue?vue&type=style&index=0&id=3c25683a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c25683a",
  null
  
)

export default component.exports